const routeMatchedMap = new Map();
export function setMatchedRoute(id, match) {
  routeMatchedMap.set(id, match);
}
export function getMatchedRoute(id) {
  return routeMatchedMap.get(id);
}
export function clearMatchedRoutes() {
  return routeMatchedMap.clear();
}
//# sourceMappingURL=routeMatchedMap.js.map